module.exports = __webpack_public_path__ + "static/media/ua.3b5d3dc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/ua.svg
// module id = 1473
// module chunks = 0